import React from 'react';
import { connect } from 'react-redux';
import { Form, Control, Errors } from 'react-redux-form';
import get from 'lodash/get';

import BaseDetailScreen from '../BaseDetailScreen';
import ResetConfirmation from './ResetConfirmation';
import Button from '../Button';
import { updateCredentials } from '../../actions';
import { baseResetPwdPath } from '../Forms/Schemas/baseRrf';
import { validateEmail, validatePassword, validatePasswordChars } from '../Forms/Validators';
import InputField from '../Forms/Controls/Field';

import './style.css';


const fields = [{
  model: '.email',
  RRFComp: Control.text,
  control: {
    placeholder: 'Email',
    type: 'email',
    errors: {
      required: val => !val || !val.length,
      isEmail: val => val && !validateEmail(val),
    },
  },
  error: {
    messages: {
      required: 'Please provide your email address.',
      isEmail: val => `${val} is not a valid Email Address.`,
    },
  },
}, {
  model: '.passphrase',
  RRFComp: Control.text,
  control: {
    type: 'password',
    placeholder: 'Password',
    errors: {
      required: val => !val || !val.length,
      length: val => val && !validatePassword(val),
      chars: val => val && !validatePasswordChars(val),
    },
  },
  error: {
    messages: {
      required: 'Please enter a password.',
      length: 'Password must be at least 8 characters.',
      chars: 'Value must contain at least one uppercase letter, one lowercase letter, one number and one special character (!@#$%^&*).',
    },
  },
}, {
  model: '.verifyPassphrase',
  RRFComp: Control.text,
  control: {
    type: 'password',
    placeholder: 'Confirm Password',
    errors: {
      required: val => !val || !val.length,
    },
  },
  error: {
    messages: {
      required: 'Please confirm your password.',
    },
  },
}];

const returnErrorMessage = (error) => {
  const errors = [
    get(error, 'validationErrors.passphrase.msg'),
    get(error, 'validationErrors.email.msg'),
    get(error, 'validationErrors.token.msg'),
    error.message,
  ];
  return errors.filter(e => e)[0];
};


class ResetPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      submitting: false,
      confirmed: false,
    };

    this.onSubmit = this.onSubmit.bind(this);
  }

  async onSubmit() {
    if (!this.state.submitting) {
      this.setState({ submitting: true });
    } else {
      return;
    }

    const {
      email,
      passphrase,
    } = this.props.resetPwdForm;

    try {
      await this.props.saveCredentials(email, passphrase, this.props.token);

      this.setState({
        submitting: false,
        confirmed: true,
      });
    } catch (err) {
      const { error } = await err.res.json();
      this.setState({ error: returnErrorMessage(error), submitting: false });
    }
  }

  render() {
    if (this.state.confirmed) {
      return (
        <ResetConfirmation />
      );
    }

    return (
      <BaseDetailScreen
        pageHeading="Reset Password"
        backTo="/"
        backLabel="Home"
      >
        <div styleName="main">
          { this.state.error ?
            (
              <div styleName="errorInstructions">
                { this.state.error }
              </div>
            ) : (
              <div styleName="instructions">
                Please type in your new password.
              </div>
            )
          }
          <Form
            model={baseResetPwdPath}
            onSubmit={this.onSubmit}
            validators={{
              '': {
                passwordsMatch: (vals) => {
                  if (vals.passphrase && vals.verifyPassphrase) {
                    return vals.passphrase === vals.verifyPassphrase;
                  }
                  return true;
                },
              },
            }}
          >
            { fields.map(field => (
              <InputField
                key={field.model}
                fieldProps={field}
              />
              ))
            }
            <Errors
              styleName="errorText"
              show={form => form.touched || form.submitted}
              model={baseResetPwdPath}
              messages={{
                passwordsMatch: 'Passwords must match.',
              }}
            />
            <div styleName="submitButtonContainer">
              <Button type="submit">
                Reset Password
              </Button>
            </div>
          </Form>
        </div>
      </BaseDetailScreen>
    );
  }
}

const mapStateToProps = (state, { match: { params: { token } } }) => ({
  resetPwdForm: state.resetPwdForm,
  token,
});

const mapDispatchToProps = dispatch => ({
  saveCredentials: (...args) => (
    dispatch(updateCredentials(...args))
  ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ResetPassword);



// WEBPACK FOOTER //
// ./src/components/ResetPassword/index.js